import axiosInstance from "../../axios";
import { GET_RISK_ASSESSMENT_REQUEST } from "../types/riskAssessmentTypes";
import {
  requestFailed,
  requestStarted,
  requestSucceeded,
} from "./feedbackActionCreators";
import { alertSuccess } from "../../utils/feedback";
import { claimOrgScopedRequest } from "./orgScopedRequest";

export const getRiskAssessmentRequest = (riskAssessment) => {
  return {
    type: GET_RISK_ASSESSMENT_REQUEST,
    payload: riskAssessment,
  };
};

export const fetchRiskAssessment = (orgaId) => {
  return async (dispatch) => {
    const isCurrent = claimOrgScopedRequest("risk_assessment");
    dispatch(requestStarted("risk_assessment"));
    // Dropped before the request leaves - see orgScopedRequest.
    dispatch(getRiskAssessmentRequest({ user_choice: "", hypotheses: [] }));

    try {
      const res = await axiosInstance.get(`/survey/risk_assessment/${orgaId}`);
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      const data = res?.data || {};

      dispatch(
        getRiskAssessmentRequest({
          user_choice: data?.user_choice || "",
          hypotheses: Array.isArray(data?.hypotheses) ? data.hypotheses : [],
        })
      );

      dispatch(requestSucceeded());
      return res;
    } catch (error) {
      if (!isCurrent()) {
        // Superseded, but the loading counter it took on the way in still has
        // to be given back: feedbackReducer counts starts against successes and
        // the global overlay sits on the total. Returning without this leaks a
        // count the page can never get back, and it hangs until a reload.
        dispatch(requestSucceeded());
        return;
      }
      dispatch(requestFailed(error?.response?.data));
    }
  };
};

export const updateRiskAssessmentHypotheses = (orgaId, ops) => {
  return async (dispatch) => {
    try {
      dispatch(requestStarted("Updating_risk_assessment"));
      const res = await axiosInstance.post(`/survey/risk_assessment_ops`, {
        orga_id: Number(orgaId),
        ops,
      });

      dispatch(fetchRiskAssessment(orgaId));
      dispatch(requestSucceeded());
      alertSuccess(res.data);
      return res.data;
    } catch (error) {
      dispatch(requestFailed(error?.response?.data));
    }
  };
};
